module.exports = __webpack_public_path__ + "static/media/wod.3b4b3bd2.svg";